import "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as r } from "../../../../context/theme/hooks.js";
import { typographyBodySizeMap as n, typographyBodyLineHeightMap as i } from "../../../../styles/typography/typography.js";
import "react-select";
import m from "../../Dropdown/hooks/useGetDropdownStyles.js";
function d() {
  const t = m({
    // Need to update custom components to support errors and other sizes
    size: "small",
    error: !1
  }), e = r();
  return {
    ...t,
    control: (o) => ({
      ...o,
      display: "none"
    }),
    menu: (o) => ({
      ...o,
      marginTop: "0px"
    }),
    menuList: (o) => ({
      ...o,
      backgroundColor: e.foreground,
      color: e["neutral-high-content"]
    }),
    groupHeading: (o) => ({
      ...o,
      color: e["neutral-high-content"],
      fontWeight: "bold",
      textTransform: "none",
      ...n.medium,
      ...i.large
    })
  };
}
export {
  d as default
};
